// src/utils/sanChoi.js
//
// ============================================================
// 🎉 SÂN CHƠI — những thứ không dính giao diện (Đợt N7, 15/09/2026)
// ------------------------------------------------------------
// Tách ra để THỬ ĐƯỢC (sanChoi.test.js). Máy chủ giữ luật thật ở
// quan-gia-api/san-choi.js.
// ============================================================

/** SC3 — 5 cảm xúc anh chốt. Mã khớp máy chủ. */
export const CAM_XUC = [
  { ma: "tim", emoji: "❤️", ten: "Thương" },
  { ma: "cuoi", emoji: "😂", ten: "Buồn cười" },
  { ma: "vo_tay", emoji: "👏", ten: "Hoan hô" },
  { ma: "wow", emoji: "😮", ten: "Ngạc nhiên" },
  { ma: "buon", emoji: "😢", ten: "Buồn" },
];

export const ANH_TOI_DA = 6; // SC2

const emojiCua = (ma) => (CAM_XUC.find((c) => c.ma === ma) || {}).emoji || "";

/**
 * Gom người thả theo từng cảm xúc, đúng thứ tự 5 cảm xúc. Mình thì ghi "Bạn".
 * ⚠️ TRẢ TÊN, KHÔNG TRẢ SỐ (chân dung 5.4).
 *   → [{ emoji: "❤️", ten: "Ba, Mẹ" }, { emoji: "👏", ten: "Bạn" }]
 */
export const gomCamXuc = (dsCamXuc, toiId) =>
  CAM_XUC.map((c) => {
    const ten = (dsCamXuc || [])
      .filter((x) => x.loai === c.ma)
      .map((x) => (x.user_id === toiId ? "Bạn" : x.ten || "Ai đó"));
    return { emoji: c.emoji, ten: ten.join(", ") };
  }).filter((n) => n.ten !== "");

/** Cảm xúc hiện tại của mình trên một bài, hoặc null. */
export const camXucCuaToi = (dsCamXuc, toiId) => {
  const x = (dsCamXuc || []).find((c) => c.user_id === toiId);
  return x ? x.loai : null;
};

/**
 * "hôm nay 19:40" · "hôm qua 19:40" · "19:40 14/09/2026".
 * Máy chủ trả sẵn chuỗi giờ VN + số ngày đã qua — không dùng new Date() (bài học 03).
 */
export const veLucDang = (bai) => {
  const chuoi = bai?.luc_dang || "";
  const gio = chuoi.slice(0, 5);
  if (bai?.so_ngay_truoc === 0) return `hôm nay ${gio}`;
  if (bai?.so_ngay_truoc === 1) return `hôm qua ${gio}`;
  return chuoi;
};

export { emojiCua };
